import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const loc = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Toggle body class for menu-opened state
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("menu-opened");
    } else {
      document.body.classList.remove("menu-opened");
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove("menu-opened");
    };
  }, [menuOpen]);

  const toggleMenu = (e) => {
    e.preventDefault();
    setMenuOpen(!menuOpen);
  };

  const closeMenu = (e) => {
    if (e) {
      e.preventDefault();
    }
    setMenuOpen(false);
  };

  const handleNavClick = (path) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(path);
    setTimeout(() => {
      setMenuOpen(false);
    }, 200);
  };

  return (
    <>
      <header className="header-two">
        <div className="container">
          <div className="header-nav">
            <div className="navbar-header">
              <a
                id="mobile_btn"
                href="#"
                onClick={toggleMenu}
                role="button"
                aria-label="Toggle menu"
              >
                <span className="bar-icon">
                  <i className="isax isax-menu" />
                </span>
              </a>
              <div className="navbar-logo">
                <a
                  className="logo-white header-logo"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    navigate("/");
                    closeMenu();
                  }}
                >
                  <img
                    src="/assets/images/logo-black.png"
                    className="logo"
                    alt="Logo"
                  />
                </a>
                <a
                  className="logo-dark header-logo"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    navigate("/");
                    closeMenu();
                  }}
                >
                  <img
                    src="/assets/img/logo-white.svg"
                    className="logo"
                    alt="Logo"
                  />
                </a>
              </div>
            </div>
            <div className={`main-menu-wrapper ${menuOpen ? "active" : ""}`}>
              <div className="menu-header">
                <a
                  className="menu-logo"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    navigate("/");
                    closeMenu();
                  }}
                >
                  <img
                    src="/assets/images/logo-black.png"
                    className="img-fluid"
                    alt="Logo"
                  />
                </a>
                <a
                  id="menu_close"
                  className="menu-close"
                  href="#"
                  onClick={closeMenu}
                  role="button"
                  aria-label="Close menu"
                >
                  <i className="fas fa-times" />
                </a>
              </div>
              <ul className="main-nav  main-nav-1">
                <li
                  className={`has-submenu megamenu ${
                    loc.pathname === "/" ? "active" : ""
                  }`}
                  onClick={() => handleNavClick("/")}
                >
                  <a>
                    <span>Home</span>{" "}
                  </a>
                </li>
                <li
                  className={`has-submenu megamenu ${
                    loc.pathname === "/about-us" ? "active" : ""
                  }`}
                  onClick={() => handleNavClick("/about-us")}
                >
                  <a>About Us</a>
                </li>
                <li
                  className={`has-submenu megamenu ${
                    loc.pathname === "/subscription" ? "active" : ""
                  }`}
                  onClick={() => handleNavClick("/subscription")}
                >
                  <a>Pricing</a>
                </li>
                <li
                  className={`has-submenu megamenu ${
                    loc.pathname === "/blogs" ? "active" : ""
                  }`}
                  onClick={() => handleNavClick("/blogs")}
                >
                  <a>Blog</a>
                </li>
                <li
                  className={`has-submenu megamenu ${
                    loc.pathname === "/contact-us" ? "active" : ""
                  }`}
                  onClick={() => handleNavClick("/contact-us")}
                >
                  <a> Contact Us</a>
                </li>
              </ul>
            </div>
            <div className="header-btn d-flex align-items-center">
              <a
                href="#"
                style={{ textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/sign-up");
                  closeMenu();
                }}
                className="new-btn new-btn-2"
              >
                Get Started <i className="fas fa-arrow-right" />
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
